import useTranslation from "next-translate/useTranslation";
import classes from "./ListingPostedBy.module.scss";
import { RootState } from "types/RootState";
import formatUrl from "utils/FormatUrl";
import Image from "next/image";

const ListingPostedBy = ({
  listing,
  agence,
  modal,
}: {
  listing: RootState["listingsV2"]["listings"][number];
  agence: any;
  modal?: any;
}) => {
  const { t, lang } = useTranslation("villesprovincescommunes");
  const t2 = useTranslation("annonceAchat").t;
  return (
    // <a
    //   href={formatUrl(
    //     `/${agence.vitrine?.substr(17, agence.vitrine.length)}`,
    //     lang
    //   )}
    //   target="__blank"
    //   className={classes.link__container}
    // >
    <div className={classes.container}>
      <div
        className={`${classes.agenceWrapper} ${modal ? classes.fromModal : ""}`}
      >
        {listing.agence ? (
          <>
            {modal ? null : (
              <p className={classes.proposePar}>{t2("proposée par")} :</p>
            )}
            <div className={classes.imgnameWrapper}>
              <div className={classes.user_image__container}>
                {listing?.logo || agence?.user_image ? (
                  <Image
                    unoptimized
                    src={`${listing?.transaction_type === "Projets Neufs"
                      ? typeof listing?.logo == "string"
                        ? listing?.logo
                        : agence?.user_image
                      : agence?.user_image
                      }`}
                    width={41}
                    height={41}
                    alt={"agence logo"}
                    className={classes.user_image__container}
                  />
                ) : null}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <strong className={classes.agenceName}>
                  {listing.agence
                    ? listing.agence.nameEntreprise
                    : listing.agenceName
                      ? listing.agenceName
                      : ""}
                </strong>
                <strong className={classes.city}>
                  {listing?.transaction_type === "Projets Neufs"
                    ? t2("Promoteur immobilier")
                    : t2("Agence immobilière à")}{" "}
                  {listing?.transaction_type === "Projets Neufs"
                    ? t(agence?.province)
                    : agence?.city
                      ? t(agence?.city)
                      : t(agence?.province)}
                </strong>
              </div>
            </div>
          </>
        ) : (
          <p className={classes.proposePar}>
            {t2("Annonce par le propriétaire")}
          </p>
        )}
      </div>
    </div>
    // </a>
  );
};

export default ListingPostedBy;
